// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__2k-5F","view_all_btn":"card_view_all_btn__22WEV","grey_color":"card_grey_color__2EdFG"};